import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { AssessmentOverviewFormField } from './formField'
import { AssessmentOverviewQuestionnaireItem } from './questionnaire'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { RecertFormData } from '../../types/RecertFormData'
import { getAppointmentTimeWithTimezone } from '../../../helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from '../../../helpers.uncontrolled'

/**
 * Assessment Overview subsection adapter for Recert Assessment
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Extract appointment time with timezone support
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options.caregiverTimezone
    )

    return {
      [AssessmentOverviewFormField.APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(AssessmentOverviewFormField.APPOINTMENT_TIME)) {
      const appointmentTime = this.getFormDataField(AssessmentOverviewFormField.APPOINTMENT_TIME)
      const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(
        appointmentTime ?? [undefined, undefined]
      )

      mutations.push({
        linkId: AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
        value: appointmentTimeValues.at(0)
      })

      mutations.push({
        linkId: AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
        value: appointmentTimeValues.at(1)
      })
    }

    return mutations
  }
}
